import {defaultCheckinOffset, parseDateIntoHermesString} from './../../../utils/date-utils';
import {prepareSrpOfferApiRequest} from './../utils/prepareSrpOfferApiRequest';
import {AnyAction} from 'redux';
import {ThunkAction, ThunkDispatch} from 'redux-thunk';
import {AppState} from '../../../store';
import {prepareSRPApiRequest} from '../utils/prepareSrpApiRequest';
import {sendEvarData} from '@ibibo/analytics';

import {
  fetchSrpDataAction,
  toggleIsLoadingAction,
  updateFilterAction,
  updateSrpOfferDataAction,
} from './actions';
import {ISrpData, IFilters, ISrpOfferDataItem, ISrpOfferData} from './types';
import {fixedFilters} from '../utils/filter-utils';
import {ArrayTogglerBehaviorTypes} from '../../../hooks/useArrayToggler';
import {updateQueryAction} from '../../common/redux/actions';
import {IUpdate_Query} from '../../common/redux/types';
import {fetchHelper} from '../../../utils/fetchHelper';
import {getSRPData} from '@ibibo/get-hotel-srp-data';


export const removeFilterThunk = (
  filterTarget: keyof IFilters,
  value: any, // ! add types later
): ThunkAction<void, AppState, {}, AnyAction> => {
  return (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    const {srp} = getState();
    const {srpConfig} = srp;
    const {filter = {}} = srpConfig;

    // ! this is not going to scale, need to pass variations of filter states
    // such as singleSelection, multiSelection, radio, etc
    if (filter[filterTarget] && filter[filterTarget].length) {
      if (
        Object.keys(fixedFilters)
          .map(fixedFiltersItemKey => fixedFilters[fixedFiltersItemKey].name)
          .indexOf(filterTarget) > -1 &&
        fixedFilters[filterTarget].type === ArrayTogglerBehaviorTypes.singleSelect
      ) {
        filter[filterTarget] = [];
      } else {
        const [value, ...rest] = filter[filterTarget];
        filter[filterTarget] = [...rest];
      }
      dispatch(updateFilterAction(filter));
    }
    dispatch(fetchSrpDataThunk());
  };
};


export const fetchSrpDataThunk = (
  loadingMore: boolean = false,
): ThunkAction<void, AppState, {}, AnyAction> => {
  return (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    dispatch(toggleIsLoadingAction(!loadingMore && true));

    const {srp, common } = getState();
    const {destination, checkin, checkout, roomString, country} = common;
    const {srpConfig, srpData} = srp;
    const {metaPartner} = srpConfig;
    const url = prepareSRPApiRequest({
      ...srpConfig,
      destination,
      checkin,
      checkout,
      country,
      roomString,
      next: loadingMore ? srpData?.next : '',
    });
    
    getSRPData({url})
      .then((response: ISrpData) => {
        if (!response.data) {
          dispatch(
            fetchSrpDataAction(
              {data: [], city_meta_info: response.city_meta_info, next: response.next},
              loadingMore,
            ),
          );
          dispatch(toggleIsLoadingAction(false));
          return;
        }

        dispatch(fetchSrpDataAction(response, loadingMore));

        if (
          metaPartner &&
          (!destination.n || !destination._id) &&
          response &&
          response.city_meta_info
        ) {
          dispatch(
            updateQueryAction({
              destination: {_id: response.city_meta_info.vcid, n: response.city_meta_info.ct},
            } as IUpdate_Query['actionData']),
          );
        }
        dispatch(toggleIsLoadingAction(false));
      })
      .catch(err => {
        console.trace(err);
        // ! do something for error case
        dispatch(toggleIsLoadingAction(false));
        sendEvarData({
          eVar22: err.message,
        })
        // dispatch(fetchSrpDataAction({error: true}));
        // dispatch(updateHasDataAction(false));
      });
    // }
  };
};

export const fetchSrpOfferDataThunk = ({
  hotelId,
  pph,
}): ThunkAction<void, AppState, {}, AnyAction> => {
  return (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    const {common} = getState();
    const {destination, checkin, checkout, roomString} = common;
    const url = prepareSrpOfferApiRequest({
      roomString,
      checkin,
      checkout,
      destination,
      pph: pph,
      hotelId: hotelId,
    });

    fetchHelper({
      name: 'srp offer api',
      type: 'GET',
      url,
    })
      .then((response: {data: Array<ISrpOfferDataItem>}) => {
        const arg = {};
        if (response.data) {
          arg[hotelId] = {data: response.data};
          dispatch(updateSrpOfferDataAction(arg as ISrpOfferData));
        } else {
          arg[hotelId] = {error: 'Something went wrong. We are sending a fix'};
          dispatch(updateSrpOfferDataAction(arg as ISrpOfferData));
        }
      })
      .catch(err => {
        // ! do something for error case
        console.error(err);
      });
    // }
  };
};
